<template>
    <nav class="navbar is-fixed-top" role="navigation" aria-label="main-navigation">
      <div class="container">
        <div class="navbar-brand">
          <router-link class="navbar-item" to="/">
            <img
              :src="
                require('@/assets/images/JPEG/MyGymChecker-Logo-JPEG-BlackBlue.jpg')
              "
              class="navbar-logo"
            />
          </router-link>
          <a
            role="button"
            :class="['navbar-burger', { 'is-active': openMenu }]"
            aria-label="menu"
            aria-expanded="false"
            @click="menuSwitch()"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div :class="['navbar-menu', { 'is-active': openMenu }]">
          <div class="navbar-start is-hidden-desktop has-text-centered">
            <div class="navbar-item">
              <div class="columns is-gapless is-centered">
                <div
                  class="column is-narrow is-inline-block"
                  v-for="(media, index) in socials"
                  :data-index="index"
                  :key="index - 1"
                >
                  <Social class="social" :media="media" />
                </div>
              </div>
            </div>
            <div class="navbar-item mt-3 mb-3  pl-3">
              <span><i class="fas fa-dumbbell"></i></span
              ><router-link to="/register"
                ><span @click="menuSwitch()" class="nav-link bold"
                  >Register your gym</span
                ></router-link
              >
            </div>
            <div class="navbar-item mt-3 mb-3">
              <a class="nav-link bold" :href="dashboard_link" target="_blank"
                ><span><i class="fas fa-user-circle"></i></span>Sign in</a
              >
            </div>
          </div>
          <div class="navbar-end is-hidden-touch">
            <div class="navbar-item">
              <BurgerMenu />
            </div>
          </div>
        </div>
      </div>
    </nav>
</template>

<script>
import BurgerMenu from "@/components/molecules/BurgerMenu.vue";
import Social from "@/components/atoms/Social.vue";
export default {
  components: {
    BurgerMenu,
    Social,
  },
  data() {
    return {
      burgerOpen: false,
      dashboard_link: process.env.VUE_APP_BASE_DASHBOARD_URL,
      openMenu: false,
      socials: [
        {
          icon: "fab fa-youtube",
          link: "https://www.youtube.com/channel/UCMyG9qoEh2Yz3KLnCciZN-A",
          color: "#FF0000",
        },
        {
          icon: "fab fa-facebook",
          link: "https://www.facebook.com/mygymchecker/",
          color: "#1877F2",
        },
        {
          icon: "fab fa-linkedin",
          link: "https://www.linkedin.com/company/my-gym-checker",
          color: " #007BB5",
        },
        {
          icon: "fab fa-twitter",
          link: "https://twitter.com/Mygymchecker",
          color: "#1DA1F2",
        },
        {
          icon: "fab fa-instagram",
          link: "https://instagram.com/mygymchecker?r=nametag",
          color: "#C32AA3",
        },
      ],
    };
  },
  methods: {
    menuSwitch() {
      this.openMenu = !this.openMenu;
    },
  },
};
</script>

<style scoped>
.button {
  margin: 1rem;
}
.navbar {
  background: white !important;
  width: 100%;
  z-index: 99999 !important;
  margin: auto;
}

.navbar:after {
  content:"";
  position:absolute;
  width:100%;
  height: 5px;
  bottom:1px;
  z-index: 1;
  opacity: 1;
  box-shadow: inset 0px 5px 10px -8px #000000;
  margin-bottom: -5px;
}

@media (max-width: 769px) {
  .navbar {
    width: 100%;
    margin: auto;
  }
}

.navbar-wrapper {
  width: 100%;
  margin: auto;
  z-index: 5;
}

i {
  margin: 0.25rem;
  color: #00c5fd;
}

.nav-link::after {
  background: #00c5fd;
  bottom: 0;
  content: "";
  display: block;
  height: 2px;
  left: 50%;
  position: absolute;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0;
}

.nav-link:hover {
  background-color: #fafafa;
  color: #00c5fd !important;
  cursor: pointer;
  text-decoration: none;
}

.nav-link:hover:after {
  left: calc((100% - 5rem) / 2);
  width: 5rem;
}

.ml-2rem {
  margin-left: 2rem;
}

.nav-link {
  color: black;
}

.navbar-item {
  padding: 0 !important;
}

.social {
  margin: 0.25rem;
}

@media (max-width: 768px) {
  .navbar-wrapper {
    width: 100%;
  }
}
</style>
